import * as yup from "yup";

const PaymentInfoApproveStepValidation = yup.object().shape({
	isAgreementApprove: yup.boolean().isTrue().required(),
});

export default PaymentInfoApproveStepValidation;
